import { prefixPluginTranslations } from '@strapi/helper-plugin';
import pluginPkg from '../../package.json';
import pluginId from './pluginId';
import Initializer from './components/Initializer';
import Wysiwyg from './components/Wysiwyg';
import { createAxiosClient } from '#shared/api/axiosClient';
const name = pluginPkg.strapi.name;
export default {
  register(app) {
    createAxiosClient(strapi);
    app.registerPlugin({
      id: pluginId,
      initializer: Initializer,
      isReady: false,
      name
    });
    app.addFields({
      type: 'wysiwyg',
      Component: Wysiwyg
    });
  },
  bootstrap(app) {},
  async registerTrads({
    locales
  }) {
    const importedTrads = await Promise.all(locales.map(locale => {
      return import(`./translations/${locale}.json`).then(({
        default: data
      }) => {
        return {
          data: prefixPluginTranslations(data, pluginId),
          locale
        };
      }).catch(() => {
        return {
          data: {},
          locale
        };
      });
    }));
    return Promise.resolve(importedTrads);
  }
};